import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Create the root from the 'root' div in public/index.html
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render your main <App /> component.
// StrictMode is optional but helps identify potential problems in development.
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
